import React, { useEffect, useState } from "react";

const DoctorSearch = ({
  allDoctors = [],
  isLoadingDoctors = false,
  doctorsLoadError = null,
  onDoctorSelected,
  description = "Search for a doctor, then browse their patients by day.",
  label = "Doctor name",
}) => {
  const [doctorSearch, setDoctorSearch] = useState("");
  const [filteredDoctors, setFilteredDoctors] = useState([]);

  useEffect(() => {
    if (doctorSearch.trim()) {
      const search = doctorSearch.trim().toLowerCase();
      setFilteredDoctors(
        allDoctors.filter((doc) => {
          const name = doc.user_name?.toLowerCase() || "";
          const id = doc.user_id?.toLowerCase() || "";
          const email = doc.user_email?.toLowerCase() || "";
          return name.includes(search) || id.includes(search) || email.includes(search);
        })
      );
    } else {
      setFilteredDoctors([]);
    }
  }, [doctorSearch, allDoctors]);

  return (
    <div className="space-y-3">
      <p className="text-sm text-gray-600">
        {description}
      </p>
      <label htmlFor="doctorSearch" className="block text-sm font-medium text-gray-700">
        {label}
      </label>
      <input
        id="doctorSearch"
        type="text"
        autoComplete="off"
        value={doctorSearch}
        onChange={(e) => setDoctorSearch(e.target.value)}
        placeholder="Type to search for a doctor..."
        className="w-full max-w-md px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-ktx-purple focus:border-ktx-purple"
      />
      {isLoadingDoctors && (
        <p role="status" className="text-sm text-gray-500">Loading doctors…</p>
      )}
      {doctorsLoadError && (
        <p role="alert" className="text-sm text-red-600">{doctorsLoadError}</p>
      )}
      {doctorSearch && filteredDoctors.length > 0 && (
        <div className="w-full max-w-md max-h-56 overflow-y-auto border border-gray-200 rounded-md bg-white shadow">
          {filteredDoctors.map((doc) => (
            <button
              key={doc.user_id}
              type="button"
              className="w-full text-left px-4 py-2 hover:bg-purple-100 border-b border-gray-100 last:border-b-0"
              onClick={() => {
                onDoctorSelected(doc);
                setDoctorSearch("");
              }}
            >
              <div className="font-semibold text-gray-900">
                {doc.user_name}
                {doc.user_email ? (
                  <span className="text-xs text-gray-500 font-normal ml-1">
                    ({doc.user_email})
                  </span>
                ) : null}
              </div>
            </button>
          ))}
        </div>
      )}
      {doctorSearch &&
        !isLoadingDoctors &&
        !doctorsLoadError &&
        filteredDoctors.length === 0 && (
        <p className="text-sm text-gray-500">No doctors found.</p>
      )}
    </div>
  );
};

export default DoctorSearch;
